<app-base-drawer
  [name]="'custom-drawer'"

  [style]="'width: '+size+'rem; z-index: 999'">

  <div
    class="custom-drawer-wrapper"
    *ngIf="customDrawer$ | async as customDrawer">
    <ng-container *ngComponentOutlet="customDrawer.content"></ng-container>
  </div>
</app-base-drawer>